/**
 * Runtime configuration module. Selects the correct API base URLs and feature
 * flags based on the current environment and exposes a `getToken` helper.
 *
 * @module config
 * @author Snowfly
 * @version 1.0.0
 */

/**
 * The API base URL derived from the current browser origin, with an optional
 * port override from `REACT_APP_API_BASE_PORT`.
 *
 * @type {string}
 */
const apiBaseUrl = `${window.location.protocol}//${window.location.hostname}`+
    (process.env.REACT_APP_API_BASE_PORT ? `:${process.env.REACT_APP_API_BASE_PORT}` : '');
/**
 * Active runtime configuration built from environment variables.
 *
 * @type {{API_BASE_URL: string, MOCK_URL: string, SF_API_BASE_URL: string, hideSFRelatedData: boolean, snowFlyAudioMerge: boolean}}
 */
const envConfig = {
    API_BASE_URL: apiBaseUrl,
    MOCK_URL: process.env.REACT_APP_MOCK_URL,
    SF_API_BASE_URL: process.env.REACT_APP_SF_API_BASE_URL,
    hideSFRelatedData: process.env.REACT_APP_NODE_ENV.indexOf('prod') > -1,
    snowFlyAudioMerge: true, //false,
};

/**
 * Returns the current authentication token formatted as a Bearer string,
 * reading it from localStorage on each call.
 *
 * @returns {string} The Authorization header value, e.g. `"Bearer <token>"`.
 */
const getToken = () => `Bearer ${localStorage.getItem('token')}`;

/**
 * The name of the active environment, resolved from `REACT_APP_NODE_ENV`,
 * falling back to `REACT_APP_STAGE`, then to `'stage'`.
 *
 * @type {string}
 */
const curEnv = process.env.REACT_APP_NODE_ENV ?? process.env.REACT_APP_STAGE ?? 'stage';

console.log(process.env);
console.log('process.env.NODE_ENV = ', process.env.REACT_APP_NODE_ENV);
console.log('process.env.REACT_APP_STAGE = ', process.env.REACT_APP_STAGE);
console.log('Using config[%s] = %o', curEnv, envConfig);
//console.log('Using config[%s] = %o', curEnv, {...envConfig});

export default {
    getToken,
    ...envConfig,
    //...env[curEnv],
};
